import * as React from "react";
const SvgStop = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", height: "1em", fill: "none", viewBox: "0 0 16 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("rect", { width: 16, height: 16, fill: "currentColor", rx: 2 }));
export {
  SvgStop as default
};
//# sourceMappingURL=stop.js.map
